var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "flex-grid",
    { staticClass: "settings-header", attrs: { "align-items": "center" } },
    [
      _c("flex-grid-item", { attrs: { grow: "1" } }, [
        _c("h2", [_vm._v(_vm._s(_vm.displayTitle))])
      ]),
      _vm._v(" "),
      _c(
        "flex-grid-item",
        { attrs: { width: "40px" } },
        [
          _c("button-icon", {
            attrs: { icon: "icon_delete-thin", size: "30px" },
            on: { click: _vm.onCloseClick }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-201604f3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-201604f3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/containers/settings-modal/components/settings-header.vue
// module id = 1573
// module chunks = 0